import React, { useEffect, useState } from 'react'
import API from '../../services/API'
import Autocomplete from '@mui/material/Autocomplete'
import FormControl from '@mui/material/FormControl'
import TextField from '@mui/material/TextField'

const AssignedTo = ({ onChange, value, hideLabel }) => {
  const [recipientList, setRecipientList] = useState([])
  useEffect(() => {
    API.get('/task-recipients')
      .then((res) => res.status === 200 && setRecipientList(res.data))
      .catch((e) => console.log(e))
  }, [])
  const [teamsOptions, setTeamsOptions] = useState([])
  useEffect(() => {
    API.get('/settings?select=teams%20additionalTeams').then((res) => {
      if (res.status === 200) {
        setTeamsOptions([...res.data.teams, ...res.data.additionalTeams])
      }
    })
  }, [])
  return (
    <FormControl fullWidth>
      <Autocomplete
        options={[...teamsOptions, ...recipientList]}
        value={value}
        onChange={onChange}
        groupBy={(option) => (option._id ? 'Users' : 'Groups')}
        getOptionLabel={(option) =>
          option._id ? option.firstName + ' ' + option.lastName : option
        }
        isOptionEqualToValue={(option, value) =>
          typeof value === 'string'
            ? option === value
            : option._id === value._id
        }
        renderInput={(params) => (
          <TextField {...params} label={!hideLabel ? "Assigned To" : null} required />
        )}
      />
    </FormControl>
  )
}

export default AssignedTo
